/* unplugin-vue-components disabled */import { render } from "./InstallPWA.vue?vue&type=template&id=1de812e0&scoped=true"
import script from "./InstallPWA.vue?vue&type=script&lang=js"
export * from "./InstallPWA.vue?vue&type=script&lang=js"

import "./InstallPWA.vue?vue&type=style&index=0&id=1de812e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de812e0"]])

export default __exports__